export const eventLabels = {
    DONE_CONTACT_BUTTON_CLICK: 'DONE_CONTACT_BUTTON_CLICK',
    MATCH_CARD_CLICK: 'MATCH_CARD_CLICK',
    GLOBAL_TRANSFER_OPEN: 'GLOBAL_TRANSFER_OPEN',
    GLOBAL_TRANSFER_INITIATE: 'GLOBAL_TRANSFER_INITIATE',
    GLOBAL_TRANSFER_CLOSE: 'GLOBAL_TRANSFER_CLOSE',
    INLINE_TRANSFER_OPEN: 'INLINE_TRANSFER_OPEN',
    INLINE_TRANSFER_INITIATE: 'INLINE_TRANSFER_INITIATE',
    TRANSFER_CLOSE: 'TRANSFER_CLOSE',
    CONTACT_ACTIONS_MODAL_OPEN_FOR_TRANSFER: 'CONTACT_ACTIONS_MODAL_OPEN_FOR_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_EMAIL_TRANSFER: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_EMAIL_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_CONFIRM_TRANSFER: 'CUSTOMER_SUPPORT_ACTION_CONFIRM_TRANSFER',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_CHAT_TRANSFER_FORM: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_CHAT_TRANSFER_FORM',
    CUSTOMER_SUPPORT_ACTION_SEND_PHONE_LINK: 'CUSTOMER_SUPPORT_ACTION_SEND_PHONE_LINK',
    THREE_WAY_CALL_CANCEL: 'THREE_WAY_CALL_CANCEL',
    THREE_WAY_CALL_LEAVE: 'THREE_WAY_CALL_LEAVE',
    THREE_WAY_CALL_MERGE: 'THREE_WAY_CALL_MERGE',
    CUSTOMER_SUPPORT_ACTION_SUBMIT_TRANSFER_ESCALATION: 'CUSTOMER_SUPPORT_ACTION_SUBMIT_TRANSFER_ESCALATION',
    WORKFLOW_INGRESS_CLICK: 'WORKFLOW_INGRESS_CLICK',
    WORKFLOW_CONTINUE_CLICK: 'WORKFLOW_CONTINUE_CLICK',
    WORKFLOW_INTERVENTION_CLICK: 'WORKFLOW_INTERVENTION_CLICK',
    WORKFLOW_SUBMIT_CLICK: 'WORKFLOW_SUBMIT_CLICK',
    WORKFLOW_CLOSE_CLICK: 'WORKFLOW_CLOSE_CLICK',
    SOLVE_CARD_OPEN_PRIMARY_VIEW: 'SOLVE_CARD_OPEN_PRIMARY_VIEW',
    SOLVE_CARD_OPEN_ACTION_VIEW: 'SOLVE_CARD_OPEN_ACTION_VIEW',
    // We should remove WORKFLOW_STEP_INITIALIZED: https://issues.amazon.com/issues/caracara-46528
    WORKFLOW_STEP_INITIALIZED: 'WORKFLOW_STEP_INITIALIZED',
    WORKFLOW_STEP_INITIALIZING: 'WORKFLOW_STEP_INITIALIZING',
    WORKFLOW_STEP_READY: 'WORKFLOW_STEP_READY',
    // Resource menu
    RESOURCE_MENU_POP_OVER_OPEN: 'RESOURCE_MENU_POP_OVER_OPEN',
    RESOURCE_MENU_POP_OVER_READY: 'RESOURCE_MENU_POP_OVER_READY'
};
//# sourceMappingURL=constants.js.map